import type { KickerId, Pace, ReactionId, RoomSettings } from './types.ts';

export const MIN_PLAYERS = 4;
export const DEFAULT_MAX_PLAYERS = 10;

export const NAME_MAX = 20;
export const ANSWER_MAX = 240;
export const HEADLINE_MAX = 140;
export const SUBTITLE_MAX = 180;
/** Shorter headlines are treated as empty drafts and never printed. */
export const HEADLINE_MIN = 8;

/** Four-letter room codes, without I and O which read as 1 and 0. */
export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
export const CODE_LENGTH = 4;

export const KICKERS: readonly KickerId[] = ['exclusive', 'scandal', 'revelations', 'spotted', 'indiscretion', 'breaking'];
export const REACTIONS: readonly ReactionId[] = ['deny', 'nocomment', 'confess', 'lawyer', 'nonsense', 'never'];

export const POINTS = {
  /** Investigator guessed true/false right. */
  truth: 1,
  /** Investigator named the author. */
  authorFound: 2,
  /** Author, per investigator fooled on true/false. */
  authorFooled: 2,
  /** Author, when nobody named them. */
  undetected: 3,
  /** Victim, per investigator fooled on true/false. */
  victimFooled: 1,
  /** Corbeau, when none of their rumors was ever traced back to them. */
  corbeauEscaped: 5,
} as const;

export interface PhaseDurations {
  confessions: number;
  writing: number;
  publication: number;
  investigation: number;
  reveal: number;
  plume: number;
}

const SECOND = 1000;

export const PHASE_DURATIONS: Record<Pace, PhaseDurations> = {
  relaxed: {
    confessions: 240 * SECOND,
    writing: 300 * SECOND,
    publication: 14 * SECOND,
    investigation: 40 * SECOND,
    reveal: 16 * SECOND,
    plume: 40 * SECOND,
  },
  normal: {
    confessions: 180 * SECOND,
    writing: 240 * SECOND,
    publication: 13 * SECOND,
    investigation: 30 * SECOND,
    reveal: 14 * SECOND,
    plume: 30 * SECOND,
  },
  fast: {
    confessions: 120 * SECOND,
    writing: 180 * SECOND,
    publication: 12 * SECOND,
    investigation: 20 * SECOND,
    reveal: 11 * SECOND,
    plume: 20 * SECOND,
  },
};

export const DEFAULT_SETTINGS: RoomSettings = {
  intensity: 'soft',
  adultsConfirmed: false,
  questionsPerPlayer: 4,
  corbeau: false,
  pace: 'normal',
  uniformTypography: true,
};

export const QUESTIONS_PER_PLAYER_OPTIONS = [4, 5] as const;
